var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-width-1-1@l"},[_c('div',{directives:[{name:"vk-height-viewport",rawName:"v-vk-height-viewport"}],staticClass:"uk-background-cover uk-width-1-1@l animate-opacity",style:(_vm.style)}),_vm._v(" "),(!_vm.style.opacity)?_c('vk-spinner',{staticClass:"uk-position-absolute uk-position-center",attrs:{"ratio":"1.5"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1f50d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FullScreenPhoto.vue
// module id = null
// module chunks = 